import Link from 'next/link';
import React from 'react';
import { PictureWithFallback } from '../../../sections/PictureWithFallback';
import { CloseIcon } from '../../../svg/CloseIcon';
import { gql } from '@urql/core';
import {
    CollegeChatBubblesFragment,
    CollegeSelectedConversationFragment,
    Espin_Message_Type_Enum,
} from '../../../../generated/spin-graphql';
import { CollegeChatBubbles } from './CollegeChatBubbles';

type Props = {
    onBackClicked: () => void;
    selectedConversation: CollegeSelectedConversationFragment[];
};

gql`
    fragment CollegeSelectedConversation on espin_message {
        ...CollegeChatBubbles
        player_user {
            player_profile {
                profile_image {
                    ...SpinContentImageDisplay
                }
                first_name
                last_name
                slug
            }
            deleted_at
        }
        high_school {
            id
            name
            profile_pic_file {
                ...SpinContentImageDisplay
            }
            slug
        }
    }
`;

function getConversantName(conversation: CollegeSelectedConversationFragment) {
    if (conversation.player_user) {
        return `${conversation.player_user?.player_profile?.first_name} ${conversation.player_user?.player_profile?.last_name}`;
    } else if (
        conversation.message_type === Espin_Message_Type_Enum.HighSchoolMessagesCollege ||
        conversation.message_type === Espin_Message_Type_Enum.CollegeMessagesHighSchool
    ) {
        return `${conversation.high_school?.name ?? 'A High School'}`;
    }
    return 'Deleted User';
}

function getConversantSlug(conversation: CollegeSelectedConversationFragment) {
    if (conversation.player_user) {
        return `/players/${conversation.player_user?.player_profile?.slug}`;
    } else if (conversation.high_school) {
        return `/high-schools/${conversation?.high_school?.slug}`;
    }
    return undefined;
}

export function collegeConversationSelectProfileImage(
    conversation: CollegeSelectedConversationFragment | CollegeChatBubblesFragment,
) {
    if (conversation.player_user) {
        return conversation.player_user?.player_profile?.profile_image;
    } else if (conversation.high_school) {
        return conversation.high_school.profile_pic_file;
    }
    return null;
}

export const CollegeSelectedConversation: React.FC<Props> = ({ onBackClicked, selectedConversation }) => {
    const profileImage = collegeConversationSelectProfileImage(selectedConversation[0]);
    const nameLabel = getConversantName(selectedConversation[0]);
    const slug = getConversantSlug(selectedConversation[0]);
    return (
        <>
            <div className="header-container">
                <div className="image-wrapper">
                    <PictureWithFallback
                        width={40}
                        height={40}
                        icon={profileImage}
                        alt={`${nameLabel}'s profile picture`}
                    />
                </div>
                {!!!selectedConversation[0].player_user?.deleted_at && (
                    <Link href={slug}>
                        <a className="username">{nameLabel}</a>
                    </Link>
                )}
                {!!selectedConversation[0].player_user?.deleted_at && <span className="username">{nameLabel}</span>}
                <button onClick={onBackClicked} className="button circle-button back-button">
                    <CloseIcon />
                </button>
            </div>
            <div className="content">
                <CollegeChatBubbles conversation={selectedConversation} />
            </div>
        </>
    );
};
